<!-- 车辆管理-车辆台账 -->

<template>
  <div class="vehicle-ledger main-cnt">
    <el-row style="height: 100%;">
      <el-col :span="12" style="border-right: 1px solid #e8eaee;">
        <div class="real-time-vehicles">
          <div class="top-title left-title">车辆实时大屏</div>

          <el-table :data="vehicleTableData" height="650">
            <el-table-column label="车牌" prop="plate"></el-table-column>
            <el-table-column label="状态" width="180">
              <template #default="scope">
                <!-- 车辆状态 0=候车中，1=待发车，2=运行中，3=维修中，4=保养中 -->
                <div class="status-text" :class="statusColors(scope.row.op_status, 'car')">
                  {{ scope.row.op_status_text }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="170">
              <template #default="scope">
               
                <div v-if="scope.row.op_status == 3 || scope.row.op_status == 4">
                  <div class="text-blue cursor-pointer" @click="onRepairCompletedBtn(scope.row)"
                  v-if="scope.row.op_status == 3 && authData.indexOf('n_293cff1fbf9b7ba250a3d59fb') != -1">维修结束</div>

                <div class="text-blue cursor-pointer" @click="onMaintainCompletedBtn(scope.row)"
                  v-if="scope.row.op_status == 4 && authData.indexOf('n_415496fff02f887b6f99420ae') != -1">保养结束</div>
                </div>

                <div class="flex align-center" v-else >
                  <div class="text-blue cursor-pointer" @click="onDispatchBtn(scope.row)"
                  v-if="(scope.row.op_status != 3 || scope.row.op_status == 0) && authData.indexOf('n_6dda091da04394500d9f874f1') != -1">派车</div>
                  <el-divider direction="vertical"
                    v-if="authData.indexOf('n_6dda091da04394500d9f874f1') != -1 && authData.indexOf('n_293cff1fbf9b7ba250a3d59fb') != -1" />
                  <template v-if="scope.row.op_status == 0">
                    <div class="cursor-pointer text-red" @click="onRepairBtn(scope.row)"
                    v-if="authData.indexOf('n_293cff1fbf9b7ba250a3d59fb') != -1">维修</div>

                  <el-divider direction="vertical"
                    v-if="authData.indexOf('n_293cff1fbf9b7ba250a3d59fb') != -1 && authData.indexOf('n_415496fff02f887b6f99420ae') != -1" />
                  <el-divider direction="vertical"
                    v-else-if="authData.indexOf('n_6dda091da04394500d9f874f1') != -1 && authData.indexOf('n_415496fff02f887b6f99420ae') != -1" />

                  <div class="cursor-pointer text-red" @click="onMaintainBtn(scope.row)"
                    v-if="authData.indexOf('n_415496fff02f887b6f99420ae') != -1">保养</div>
                  </template>
                  
                </div>
               
              </template>
            </el-table-column>
          </el-table>

          <div class="pour-content">口头约车的需求，您可以直接在候车车辆中选车派车，若想给某车添加乘车人，请到运营情况列表修改!</div>
        </div>
      </el-col>

      <el-col :span="12">
        <div class="system-order">
          <div class="top-title right-title">系统订单客户</div>

          <div v-if="orderTableData.length == 0" class="justify-center text-center">
            <img src="@/assets/img/no-order.png" alt="暂无订单" style="display: block; margin: 20px auto;" />
            <span>暂无订单</span>
          </div>
          <div v-else>
            <el-table :data="orderTableData" height="650">
              <el-table-column label="订单编号" prop="or_sn"></el-table-column>
              <el-table-column label="状态" width="180">
                <template #default="scope">
                  <!-- 订单状态 1=待接单，2=已接单，3=已完成，8=已取消，9=未接单 -->
                  <div class="status-text" :class="statusColors(scope.row.oc_status, 'order')">
                    {{ scope.row.status_text }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="110">
                <template #default="scope">
                  <div class="flex align-center">
                    <div class="cursor-pointer receiving-orders" @click="onClickOrderBtn(scope.row, 'accept')"
                      v-if="authData.indexOf('n_a637b9ddb665ae53b74ee7f1a') != -1">接单
                    </div>
                    <el-divider direction="vertical"
                      v-if="authData.indexOf('n_a637b9ddb665ae53b74ee7f1a') != -1 && authData.indexOf('n_d23ced39ba48a02193a18fce3') != -1" />
                    <div class="cursor-pointer text-red" @click="onClickOrderBtn(scope.row, 'refuse')"
                      v-if="authData.indexOf('n_d23ced39ba48a02193a18fce3') != -1">拒接</div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div class="pour-content">会员主动小程序约车的订单，请你根据订单派车。</div>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 派车 -->
    <CarDispatch ref="dispatchRef" @submit="onSubmit"></CarDispatch>

    <!-- 订单详情 -->
    <CarOrderDetails ref="infoRef" @submit="onClickOrderBtn"></CarOrderDetails>

    <!-- 按人接单 -->
    <CarByPerson ref="personRef" @submit="onConfirmReceivingOrders"></CarByPerson>

    <!-- 包车 -->
    <CharteredBus ref="charteredRef" @submit="onConfirmReceivingOrders"></CharteredBus>

    <!-- 拒接 -->
    <RefusalAccept ref="refuseRef" @submit="onConfirmRefuse"></RefusalAccept>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, watch } from "vue";
import { VipApi, } from "@/plugins/api.js";
import { ElMessage, ElMessageBox, } from "element-plus";
import { useStore } from "vuex";
import CarDispatch from "../components/CarDispatch.vue";
import CarOrderDetails from "../components/CarOrderDetails.vue";
import RefusalAccept from "../components/RefusalAccept.vue";
import CarByPerson from "../components/CarByPerson.vue";
import CharteredBus from "../components/CharteredBus.vue";

const store = useStore();
const menuTokens = computed(() => store.state.menuToken.menuTokens);
const authData = ref([]);
watch(
  () => menuTokens.value,
  (data) => {
    if (data.length) {
      authData.value = data;
    }
  },
  {
    deep: true,
    immediate: true,
  }
);
const vehicleTableData = ref([]);  // 车辆表格数据
const orderTableData = ref([]);  // 订单表格数据
const dispatchRef = ref(null);  // 派车弹框对象
const infoRef = ref(null);  // 订单详情弹框对象
const currentOrderRow = ref('');  // 当前订单行数据
const refuseRef = ref(null);  // 拒接弹框对象
const personRef = ref(null);  // 按人弹框对象
const charteredRef = ref(null);  // 包车弹框对象

/**
 * 
 * 获取数据
 * req_type 数据类型：1-车辆列表；2-订单列表
 * 
 * **/
const getcarDispatchLists = (req_type) => {
  VipApi.getCarDispatchLists({ req_type, }).then((res) => {
    if (res.Code == 200) {
      if (req_type == 1) {
        // 车辆列表
        vehicleTableData.value = res.Data.list;
      } else if (req_type == 2) {
        // 订单列表
        orderTableData.value = res.Data.list;
      }
    } else {
      ElMessage.error(res.Message);
    }
  });
}
/**
 * 
 * 退款状态
 * 
 * **/
const statusColors = (status, type) => {
  let op_status = '';  // 车辆状态 0=候车中，1=待发车，2=运行中，3=维修中，4=保养中
  let oc_status = '';  // 订单状态 1=待接单，2=已接单，3=已完成，8=已取消，9=未接单
  switch (status) {
    case 0:
      op_status = 'btn-green';
      break;
    case 1:
      op_status = 'btn-orange';
      oc_status = 'btn-orange';
      break;
    case 2:
      op_status = 'btn-yellow';
      oc_status = 'btn-yellow';
      break;
    case 3:
      op_status = 'btn-grey';
      oc_status = 'btn-blue';
      break;
    case 4:
      op_status = 'btn-grey';
      break;
    case 8:
      oc_status = 'btn-black';
      break;
    case 9:
      oc_status = 'btn-grey';
      break;
  }

  if (type == 'car') {
    return op_status;
  } else if (type == 'order') {
    return oc_status;
  }
}
/**
 * 
 * 派车按钮
 * 
 * **/
const onDispatchBtn = (row) => {
  dispatchRef.value.openDialog(row);
}
/**
 * 
 * 派车提交按钮
 * 
 * **/
const onSubmit = () => {
  getcarDispatchLists(1);
}
/**
 * 
 * 维修按钮
 * 
 * **/
const onRepairBtn = (row) => {
  ElMessageBox.confirm("确认维修此车吗？", "维修确认", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
  })
    .then(() => {
      VipApi.updateCarRepair({ id: row.id, }).then((res) => {
        if (res.Code == 200) {
          ElMessage.success("维修成功！");
          getcarDispatchLists(1);
        } else {
          ElMessage.error(res.Message);
        }
      });
    })
    .catch(() => { });
};
/**
 * 
 * 维修结束按钮
 * 
 * **/
const onRepairCompletedBtn = (row) => {
  ElMessageBox.confirm("维修结束，修改车辆状态为候车。", "维修结束确认", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
  })
    .then(() => {
      VipApi.updateCarRepair({ id: row.id, }).then((res) => {
        if (res.Code == 200) {
          ElMessage.success("维修完成成功！");
          getcarDispatchLists(1);
        } else {
          ElMessage.error(res.Message);
        }
      });
    })
    .catch(() => { });
}
/**
 * 
 * 保养按钮
 * 
 * **/
const onMaintainBtn = (row) => {
  ElMessageBox.confirm("确认保养此车吗？", "保养确认", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
  })
    .then(() => {
      VipApi.updateCarMaintain({ id: row.id, }).then((res) => {
        if (res.Code == 200) {
          ElMessage.success("保养成功！");
          getcarDispatchLists(1);
        } else {
          ElMessage.error(res.Message);
        }
      });
    })
    .catch(() => { });
};
/**
 * 
 * 维修结束按钮
 * 
 * **/
const onMaintainCompletedBtn = (row) => {
  ElMessageBox.confirm("保养结束，修改车辆状态为候车。", "保养结束确认", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
  })
    .then(() => {
      VipApi.updateCarMaintain({ id: row.id, }).then((res) => {
        if (res.Code == 200) {
          ElMessage.success("保养完成成功！");
          getcarDispatchLists(1);
        } else {
          ElMessage.error(res.Message);
        }
      });
    })
    .catch(() => { });
}
/**
 * 
 * 订单操作按钮
 * 
 * **/
const onClickOrderBtn = (row, type) => {
  currentOrderRow.value = row;
  if (type == 'accept') {
    // 列表接单按钮
    infoRef.value.openDialog(row);
  } else if (type == 'infoAccept') {
    // 详情接单按钮
    if (row.oc_subscribe_type == 1) {
      personRef.value.openDialog(row);
    } else {
      charteredRef.value.openDialog(row);
    }
  } else if (type == 'refuse') {
    // 拒接
    refuseRef.value.openDialog();
  }
}
/**
 * 
 * 确认接单
 * 
 * **/
const onConfirmReceivingOrders = (datas) => {
  VipApi.orderConfirmCarDispatch(datas).then(res => {
    if (res.Code == 200) {
      if (currentOrderRow.value.oc_subscribe_type == 1) {
        // 按人接单
        personRef.value.closeDialogLoading();
        personRef.value.closeDialog();
      } else {
        // 包车接单
        charteredRef.value.closeDialogLoading();
        charteredRef.value.closeDialog();
      }
      getcarDispatchLists(2);
      getcarDispatchLists(1);
      infoRef.value.closeDialog();
      ElMessage.success('接单成功！');
    } else {
      if (currentOrderRow.value.oc_subscribe_type == 1) {
        // 按人接单
        personRef.value.closeDialogLoading();
      } else {
        // 包车接单
        charteredRef.value.closeDialogLoading();
      }
      ElMessage.error(res.Message);
    }
  }).catch(() => {
    ElMessage.error('接单失败，请稍后重试！');
  });
}
/**
* 
* 拒接确定按钮
* 
* **/
const onConfirmRefuse = (data) => {
  let params = {
    order_id: currentOrderRow.value.or_id,
    reason: data,
  };
  VipApi.orderRefuseCarDispatch(params).then(res => {
    refuseRef.value.closeDialogLoading();
    if (res.Code == 200) {
      infoRef.value.closeDialog();
      getcarDispatchLists(2);
      refuseRef.value.closeDialog();
      ElMessage.success('拒绝成功！');
    } else {
      ElMessage.error(res.Message);
    }
  })
}

onMounted(() => {
  getcarDispatchLists(1);
  getcarDispatchLists(2);
});
</script>

<style lang="scss">
.vehicle-ledger {
  font-family: "Source Han Sans CN";

  .real-time-vehicles {
    padding: 15px;

    .el-table__cell {
      background-color: #F7FBFF;
      color: #5D6066;
    }
  }

  .system-order {
    padding: 15px;

    .el-table__cell {
      background-color: #F9F7FE;
      color: #5D6066;
    }

    .receiving-orders {
      color: #343FCD;
    }
  }

  .top-title {
    height: 60px;
    text-align: center;
    line-height: 60px;
    font-size: 20px;
    font-weight: bold;
  }

  .left-title {
    background: linear-gradient(90deg, rgba(236, 245, 255, 1) 0%, rgba(204, 230, 254, 1) 100%);
    color: #0072F6;
  }

  .right-title {
    background: linear-gradient(90deg, rgba(234, 230, 253, 1) 0%, rgba(202, 204, 255, 1) 100%);
    color: #343FCD;
  }

  .pour-content {
    font-size: 14px;
    color: #F0170A;
    margin-top: 10px;
  }

  .content {
    padding: 15px 20px 20px;
  }
}
</style>
